var exports = {
  "FC": "ErrorPage500__XFtoLc",
  "mc": "Container__6BJWvI",
  "gu": "Logo__9qojl4",
  "nc": "LogoImg2x__0Qh1XQ",
  "Uh": "LogoImg1x__Rig0SB",
  "CJ": "Suggestions__DELI8l",
  "X9": "ParallaxWrapper__5_W9Y1",
  "Cr": "ParallaxField__58tcHg",
  "Cw": "ParallaxIllustration__Vqsfz2",
  "Rl": "ParallaxSign__qvvDZv",
  "vW": "ParallaxOctocat__zhwQwy",
  "$U": "ParallaxErrorText__9rn86M",
  "RE": "ParallaxBg__wkR9NO",
};

module.exports = exports;
